import CustomModalBody from "components/Modal/body";
import CustomModalFooter from "components/Modal/footer";
import { useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

export default function FilterForm({ onSubmit, onChangeHOC, handleState, einvoiceMonthList, einvoiceYearList }) {
	const [invoiceStartDate, setInvoiceStartDate] = useState(null);
	const [invoiceEndDate, setInvoiceEndDate] = useState(null);
	const [invoiceNumber, setInvoiceNumber] = useState("");
	const [consolidatedEInvoiceNumber, setConsolidatedEInvoiceNumber] = useState("");
	const [einvoiceMonth, setEInvoiceMonth] = useState("");
	const [einvoiceYear, setEInvoiceYear] = useState("");

	const handleClear = () => {
		setInvoiceStartDate("");
		setInvoiceEndDate("");

		setInvoiceNumber("");
		setConsolidatedEInvoiceNumber("");

		setEInvoiceMonth("");
		setEInvoiceYear("");
	};

	const generateQuery = () => {
		let queryString = "";

		if (invoiceStartDate){ queryString += `&invoice_start_date=${invoiceStartDate}`}
		if (invoiceEndDate){ queryString += `&invoice_end_date=${invoiceEndDate}`}
		if (invoiceNumber){ queryString += `&invoice_no=${invoiceNumber}`}
		if (consolidatedEInvoiceNumber){ queryString += `&consolidated_einvoice_no=${consolidatedEInvoiceNumber}`}
		if (einvoiceMonth){ queryString += `&einvoice_month=${einvoiceMonth}`}
		if (einvoiceYear){ queryString += `&einvoice_year=${einvoiceYear}`}

		return queryString;
	};

	return (
		<>
			<CustomModalBody>
				<Form id="billing-filter-form">
					<Row>
						<Col lg={3}>
							<FormGroup>
								<Label for="einvoiceMonth">E-Invoice Month </Label>
								<Input
									type="select"
									name="einvoiceMonth"
									id="einvoiceMonth"
									value={einvoiceMonth}
									onChange={(e) => {setEInvoiceMonth(e.target.value)}}
								>
									<option value={""}>All</option>
									{einvoiceMonthList.map((item)=>{
										return <option key={item.einvoice_month} value={item.einvoice_month}>
											{item.einvoice_month}
										</option>
									})}
								</Input>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="einvoiceMonth">E-Invoice Year </Label>
								<Input
									type="select"
									name="einvoiceYear"
									id="einvoiceYear"
									value={einvoiceYear}
									onChange={(e) => {setEInvoiceYear(e.target.value)}}
								>
									<option value={""}>All</option>
									{einvoiceYearList.map((item)=>{
										return <option key={item.einvoice_year} value={item.einvoice_year}>
											{item.einvoice_year}
										</option>
									})}
								</Input>
							</FormGroup>
						</Col>

						<Col lg={3}>
							<FormGroup>
								<Label for="invoiceNumber">Invoice No.</Label>
								<Input
									placeholder="Enter Invoice No."
									name="invoiceNumber"
									id="invoiceNumber"
									value={invoiceNumber}
									onChange={(e) => {setInvoiceNumber(e.target.value)}}
								/>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="invoiceNumber">Consolidated E-Invoice No.</Label>
								<Input
									placeholder="Enter Consolidated E-Invoice No."
									name="consolidatedEInvoiceNumber"
									id="consolidatedEInvoiceNumber"
									value={consolidatedEInvoiceNumber}
									onChange={(e) => {setConsolidatedEInvoiceNumber(e.target.value)}}
								/>
							</FormGroup>
						</Col>
					</Row>
				</Form>
			</CustomModalBody>
			<CustomModalFooter
				rightButton={[
					{
						color: "danger",
						outline: true,
						content: "Clear All",
						onClick: () => handleClear(),
					},
					{
						color: "primary",
						content: "Submit",
						onClick: () => {
							const queryString = generateQuery();
							onSubmit(queryString);
							handleState({ filterQuery: queryString });
							onChangeHOC("showFilterModal", false);
							onChangeHOC("advertiserPages", 1);
						},
					},
				]}
			/>
		</>
	);
}
